export default () => {
  // elements
  const els = {
    megaMenu: document.querySelector('[data-mega-menu]'),
    megaMenuDesktop: document.querySelector('[data-mega-menu-desktop]'),
    backBtn: document.querySelectorAll('[data-mega-menu-back]'),
    parentLinks: document.querySelectorAll('[data-mega-menu-show-children]'),
    parentLinksDesktop: document.querySelectorAll('[data-mega-menu-child-id]'),
    links: document.querySelectorAll('[data-mega-menu-link]'),
    openBtn: document.querySelectorAll('[data-mega-menu-open]'),
    closeBtn: document.querySelectorAll('[data-mega-menu-close]'),
    pageHeader: document.querySelector('[data-page-header]'),
  };

  const classes = {
    levels: ['mega-menu--level-4', 'mega-menu--level-3', 'mega-menu--level-2', 'mega-menu--level-1'],
    base: 'mega-menu',
    show: 'mega-menu--show',
    desktopActive: 'mega-menu-desktop--active',
    activeLevels: ['mega-menu__level-2--active', 'mega-menu__level-3--active', 'mega-menu__level-4--active'],
    activeLinks: ['mega-menu__top-link--active', 'mega-menu__child-link--active'],
    childLinkActive: 'mega-menu__child-link--active',
  };

  const selectors = {
    activeLevels: '.mega-menu__level-2--active, .mega-menu__level-3--active, .mega-menu__level-4--active',
    activeLinks: '.mega-menu__top-link--active, .mega-menu__child-link--active',
  };

  let hoverTimer;

  // functions
  const updateTopPosition = () => {
    const { pageHeader } = els;
    const headerTop = pageHeader ? pageHeader.getBoundingClientRect().top : 0;
    const headerHeight = pageHeader ? pageHeader.clientHeight : 0;
    document.querySelector(':root').style.setProperty('--header-height', `${headerTop + headerHeight}px`);
  };
  const setLevel = (level) => {
    els.megaMenu.classList.remove(...classes.levels);
    els.megaMenu.classList.add(`${classes.base}--${level}`);
  };
  const setActiveBlock = (blockId) => {
    const targetBlock = document.querySelector(`.mega-menu-desktop__block[data-block-id="${blockId}"]`);
    const activeBlock = document.querySelector('.mega-menu-desktop__block--active');
    const { megaMenuDesktop } = els;

    if (targetBlock !== activeBlock) {
      if (targetBlock && activeBlock && megaMenuDesktop) {
        megaMenuDesktop.classList.add('mega-menu-desktop--animating');
        megaMenuDesktop.style.height = `${megaMenuDesktop.offsetHeight}px`;
        megaMenuDesktop.style.height = `${targetBlock.offsetHeight}px`;

        setTimeout(() => {
          megaMenuDesktop.classList.remove('mega-menu-desktop--animating');
          megaMenuDesktop.style.height = '';
        }, 500);
      }
      if (activeBlock) {
        activeBlock.classList.remove('mega-menu-desktop__block--active');
      }
      if (targetBlock) {
        targetBlock.classList.add('mega-menu-desktop__block--active');
      }
    }
  };

  const unsetActiveLevels = () => {
    document.querySelectorAll(selectors.activeLevels).forEach((el) => {
      el.classList.remove(...classes.activeLevels);
    });
  };

  const open = () => {
    els.megaMenu.classList.add(classes.show);
    document.body.classList.add('megamenu-open');
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    unsetActiveLevels();

    document.querySelectorAll(selectors.activeLinks).forEach((el) => {
      el.classList.remove(...classes.activeLinks);
    });

    els.megaMenu.classList.remove(classes.show, ...classes.levels);
    document.body.classList.remove('megamenu-open');
    document.body.style.overflow = '';
  };

  const openDesktop = () => {
    els.megaMenuDesktop.classList.add(classes.desktopActive);
    document.body.classList.add('megamenu-open');
    document.body.style.overflow = 'hidden';
  };
  const closeDesktop = () => {
    els.megaMenuDesktop.classList.remove(classes.desktopActive);
    document.body.classList.remove('megamenu-open');
    document.body.style.overflow = '';
  };

  // handlers
  const handleClickBack = (e) => {
    if (e.currentTarget.dataset.megaMenuBack) {
      setLevel(e.currentTarget.dataset.megaMenuBack);
    }
  };

  const handleTouchParentLink = (e) => {
    const currentLink = e.currentTarget;
    const level = currentLink.dataset.megaMenuShowChildren;
    const childLinksSelector = `[data-mega-menu-${level}]`;
    const activeClass = `${classes.base}__${level}--active`;
    const childLinks = currentLink.parentElement.querySelector(childLinksSelector);
    const previouslyActive = document.querySelectorAll(`.${activeClass}`);

    e.preventDefault();

    previouslyActive.forEach((el) => el.classList.remove(activeClass));
    childLinks.classList.add(activeClass);
    setLevel(level);
  };

  const handleDesktopHover = (e) => {
    const currentLink = e.currentTarget;
    const childId = currentLink.dataset.megaMenuChildId;

    setActiveBlock(childId);
    clearTimeout(hoverTimer);
    openDesktop();
  };

  const startMouseLeaveTimeout = (e) => {
    hoverTimer = setTimeout(() => {
      closeDesktop();
    }, 100);
  };

  // apply event handlers
  els.backBtn.forEach((el) => {
    el.addEventListener('click', handleClickBack);
  });

  els.parentLinks.forEach((el) => {
    el.addEventListener('touchend', handleTouchParentLink);
    el.addEventListener('click', handleTouchParentLink);
  });

  els.parentLinksDesktop.forEach((el) => {
    el.addEventListener('mouseenter', handleDesktopHover);
  });
  els.parentLinksDesktop.forEach((el) => {
    el.addEventListener('mouseleave', startMouseLeaveTimeout);
  });

  els.megaMenuDesktop.addEventListener('mouseenter', () => {
    clearTimeout(hoverTimer);
  });
  els.megaMenuDesktop.addEventListener('mouseleave', () => {
    startMouseLeaveTimeout();
  });

  els.openBtn.forEach((el) => {
    el.addEventListener('click', open);
  });

  els.closeBtn.forEach((el) => {
    el.addEventListener('click', close);
  });

  window.addEventListener('resize', updateTopPosition);
  window.addEventListener('load', updateTopPosition);
  updateTopPosition();
};
